import { Pipe, PipeTransform, inject } from '@angular/core';
import { CurrencyPipe } from '@angular/common';
import { CurrencyDisplay } from './types/currency-display.type';

@Pipe({
  name: 'formatCurrency',
  pure: true,
})
export class FormatCurrencyPipe implements PipeTransform {
  private readonly currencyPipe = inject(CurrencyPipe);

  transform(
    value: number | null | undefined,
    currencyCode: string = 'JPY',
    display: CurrencyDisplay = 'symbol-narrow',
    digitsInfo: string = '1.0-0',
    locale?: string,
  ): string {
    if (value === null) {
      return '';
    }

    return this.currencyPipe.transform(value, currencyCode, display, digitsInfo, locale) ?? '';
  }
}
